// import { BeastModeActionType } from './beastModeActionTypes';

import type { GenerateActionType } from '#utils/reduxUtils';

const deactivateBeastMode = () =>
  ({
    type: 'beastMode/STOP',
    activated: false,
  }) as const;

export const activateBeastMode = () =>
  ({
    type: 'beastMode/START',
    activated: true,
  }) as const;

const BeastModeActionCreators = {
  deactivateBeastMode,
  activateBeastMode,
};

export type BeastModeAction = GenerateActionType<typeof BeastModeActionCreators>;
